import PartnerDiesComp from "../../Components/PartnerDiesComp";
const PartnerDies = () => {
  return (
    <>
      <PartnerDiesComp />
    </>
  );
};

export default PartnerDies;
